import {NEWS_FEED_LOAD, NEWS_FEED_SET} from "./newsFeedActions";

const init = {
    items: null,
    loading: false,
    sport: null
};

export const newsFeedReducer = (state = init, action) => {
    switch (action.type) {
        case NEWS_FEED_SET:
            return {...state, items: action.payload.items || [], sport: action.payload.sport, loading: false};
        case NEWS_FEED_LOAD:
            return {...state, sport: action.payload.sport, loading: true};
        default:
            return state;
    }
};